import React from 'react';

import { CalendarContainer } from './CalendarContainer';

export const Calendar = () => {
  return <CalendarContainer />;
};
